<template>
    <div class="dict-page">
        <div class="page-header">
            <div>
                <div class="page-title">字典管理</div>
                <div class="page-subtitle">左侧维护字典类型，右侧维护当前类型下的字典项。</div>
            </div>
        </div>

        <div class="dict-layout">
            <el-card shadow="never" class="dict-type-card">
                <template #header>
                    <div class="card-header">
                        <span>字典类型</span>
                        <el-button type="primary" size="small" @click="openTypeDialog()">新增</el-button>
                    </div>
                </template>

                <el-form :model="typeSearch" label-width="70px" class="compact-form">
                    <el-form-item label="编码">
                        <el-input v-model="typeSearch.dictCode" clearable placeholder="THIRD_PARTY_VENDOR" @keyup.enter="loadTypes" />
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="typeSearch.dictName" clearable placeholder="第三方厂商" @keyup.enter="loadTypes" />
                    </el-form-item>
                    <div class="search-actions">
                        <el-button type="primary" size="small" @click="searchTypes">查询</el-button>
                        <el-button size="small" @click="resetTypeSearch">重置</el-button>
                    </div>
                </el-form>

                <el-table
                    :data="dictTypes"
                    border
                    stripe
                    highlight-current-row
                    v-loading="typeLoading"
                    height="calc(100vh - 350px)"
                    @row-click="selectType"
                >
                    <el-table-column prop="dictCode" label="编码" min-width="170" show-overflow-tooltip />
                    <el-table-column prop="dictName" label="名称" min-width="120" show-overflow-tooltip />
                    <el-table-column label="状态" width="74" align="center">
                        <template #default="scope">
                            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
                                {{ scope.row.status === 1 ? "启用" : "停用" }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="170">
                        <template #default="scope">
                            <el-button size="small" link type="primary" @click.stop="openTypeDialog(scope.row)">编辑</el-button>
                            <el-button size="small" link :type="scope.row.status === 1 ? 'warning' : 'success'" @click.stop="toggleTypeStatus(scope.row)">
                                {{ scope.row.status === 1 ? "停用" : "启用" }}
                            </el-button>
                            <el-button size="small" link type="danger" @click.stop="removeType(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination-box">
                    <el-pagination
                        small
                        background
                        layout="prev, pager, next"
                        v-model:current-page="typePage.current"
                        v-model:page-size="typePage.size"
                        :total="typePage.total"
                        @current-change="loadTypes"
                    />
                </div>
            </el-card>

            <el-card shadow="never" class="dict-item-card">
                <template #header>
                    <div class="card-header">
                        <div>
                            <span>字典明细</span>
                            <span class="selected-dict" v-if="selectedDict">{{ selectedDict.dictName }} / {{ selectedDict.dictCode }}</span>
                        </div>
                        <el-button type="primary" size="small" :disabled="!selectedDict" @click="openItemDialog()">新增明细</el-button>
                    </div>
                </template>

                <el-empty v-if="!selectedDict" description="请选择左侧字典类型" />
                <template v-else>
                    <el-form :model="itemSearch" label-width="72px" class="item-search-form">
                        <el-row :gutter="12">
                            <el-col :span="7">
                                <el-form-item label="项编码">
                                    <el-input v-model="itemSearch.itemCode" clearable placeholder="CHENGHAO" @keyup.enter="searchItems" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="项名称">
                                    <el-input v-model="itemSearch.itemName" clearable placeholder="诚浩" @keyup.enter="searchItems" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="状态">
                                    <el-select v-model="itemSearch.status" clearable placeholder="全部" style="width: 100%">
                                        <el-option label="启用" :value="1" />
                                        <el-option label="停用" :value="0" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <div class="inline-actions">
                                    <el-button type="primary" @click="searchItems">查询</el-button>
                                    <el-button @click="resetItemSearch">重置</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>

                    <el-table :data="dictItems" border stripe v-loading="itemLoading" height="calc(100vh - 350px)">
                        <el-table-column prop="itemCode" label="项编码" min-width="170" show-overflow-tooltip />
                        <el-table-column prop="itemName" label="项名称" min-width="150" show-overflow-tooltip />
                        <el-table-column prop="sortOrder" label="排序" width="80" align="center" />
                        <el-table-column label="状态" width="90" align="center">
                            <template #default="scope">
                                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? "启用" : "停用" }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
                        <el-table-column prop="updatedTime" label="更新时间" min-width="170" show-overflow-tooltip />
                        <el-table-column fixed="right" label="操作" width="220">
                            <template #default="scope">
                                <el-button size="small" @click="openItemDialog(scope.row)">编辑</el-button>
                                <el-button size="small" :type="scope.row.status === 1 ? 'warning' : 'success'" @click="toggleItemStatus(scope.row)">
                                    {{ scope.row.status === 1 ? "停用" : "启用" }}
                                </el-button>
                                <el-button size="small" type="danger" @click="removeItem(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="pagination-box">
                        <el-pagination
                            background
                            layout="total, sizes, prev, pager, next"
                            v-model:current-page="itemPage.current"
                            v-model:page-size="itemPage.size"
                            :total="itemPage.total"
                            :page-sizes="itemPage.sizes"
                            @current-change="loadItems"
                            @size-change="handleItemSizeChange"
                        />
                    </div>
                </template>
            </el-card>
        </div>

        <el-dialog v-model="typeDialog.visible" :title="typeDialog.form.id ? '编辑字典' : '新增字典'" width="560px">
            <el-form :model="typeDialog.form" label-width="92px">
                <el-form-item label="字典编码" required>
                    <el-input v-model="typeDialog.form.dictCode" placeholder="THIRD_PARTY_VENDOR" />
                </el-form-item>
                <el-form-item label="字典名称" required>
                    <el-input v-model="typeDialog.form.dictName" placeholder="第三方厂商" />
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="typeDialog.form.sortOrder" :min="0" :controls="false" style="width: 100%" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio-group v-model="typeDialog.form.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="typeDialog.form.remark" type="textarea" :rows="3" placeholder="可选" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="typeDialog.visible = false">取消</el-button>
                <el-button type="primary" :loading="saving" @click="saveType">保存</el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="itemDialog.visible" :title="itemDialog.form.id ? '编辑字典项' : '新增字典项'" width="560px">
            <el-form :model="itemDialog.form" label-width="92px">
                <el-form-item label="所属字典">
                    <el-input :model-value="selectedDict ? selectedDict.dictCode : ''" disabled />
                </el-form-item>
                <el-form-item label="项编码" required>
                    <el-input v-model="itemDialog.form.itemCode" placeholder="CHENGHAO" />
                </el-form-item>
                <el-form-item label="项名称" required>
                    <el-input v-model="itemDialog.form.itemName" placeholder="诚浩" />
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="itemDialog.form.sortOrder" :min="0" :controls="false" style="width: 100%" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio-group v-model="itemDialog.form.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="itemDialog.form.remark" type="textarea" :rows="3" placeholder="可选" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="itemDialog.visible = false">取消</el-button>
                <el-button type="primary" :loading="saving" @click="saveItem">保存</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
    deleteDictItemFun,
    deleteDictTypeFun,
    getDictItemPageFun,
    getDictTypePageFun,
    saveDictItemFun,
    saveDictTypeFun,
    updateDictItemStatusFun,
    updateDictTypeStatusFun,
} from "@/api/dict";

const typeLoading = ref(false);
const itemLoading = ref(false);
const saving = ref(false);
const dictTypes = ref([]);
const dictItems = ref([]);
const selectedDict = ref(null);
const typeSearch = reactive({ dictCode: "", dictName: "", status: "" });
const itemSearch = reactive({ itemCode: "", itemName: "", status: "" });
const typePage = reactive({ current: 1, size: 20, total: 0 });
const itemPage = reactive({ current: 1, size: 20, total: 0, sizes: [20, 50, 100] });
const typeDialog = reactive({ visible: false, form: {} });
const itemDialog = reactive({ visible: false, form: {} });

function emptyTypeForm() {
    return { id: null, dictCode: "", dictName: "", sortOrder: 0, status: 1, remark: "" };
}

function emptyItemForm() {
    return { id: null, dictCode: selectedDict.value?.dictCode || "", itemCode: "", itemName: "", sortOrder: 0, status: 1, remark: "" };
}

function loadTypes() {
    typeLoading.value = true;
    return getDictTypePageFun({ ...typeSearch, current: typePage.current, size: typePage.size })
        .then((res) => {
            const records = res.data?.records || [];
            dictTypes.value = records;
            typePage.total = res.data?.total || 0;
            if (selectedDict.value) {
                const latest = records.find((item) => item.id === selectedDict.value.id || item.dictCode === selectedDict.value.dictCode);
                selectedDict.value = latest || records[0] || null;
            } else {
                selectedDict.value = records[0] || null;
            }
            if (selectedDict.value) {
                loadItems();
            } else {
                dictItems.value = [];
                itemPage.total = 0;
            }
        })
        .finally(() => {
            typeLoading.value = false;
        });
}

function searchTypes() {
    typePage.current = 1;
    loadTypes();
}

function resetTypeSearch() {
    typeSearch.dictCode = "";
    typeSearch.dictName = "";
    typeSearch.status = "";
    searchTypes();
}

function selectType(row) {
    selectedDict.value = row;
    resetItemSearch(false);
    loadItems();
}

function openTypeDialog(row) {
    typeDialog.form = row ? { ...row } : emptyTypeForm();
    typeDialog.visible = true;
}

function saveType() {
    if (!typeDialog.form.dictCode || !typeDialog.form.dictName) {
        ElMessage.warning("请填写字典编码和名称");
        return;
    }
    saving.value = true;
    saveDictTypeFun(typeDialog.form)
        .then((res) => {
            if (res.code === 200) {
                ElMessage.success("保存成功");
                typeDialog.visible = false;
                loadTypes();
            }
        })
        .finally(() => {
            saving.value = false;
        });
}

function toggleTypeStatus(row) {
    const status = row.status === 1 ? 0 : 1;
    updateDictTypeStatusFun(row.id, status).then((res) => {
        if (res.code === 200) {
            ElMessage.success(status === 1 ? "已启用" : "已停用");
            loadTypes();
        }
    });
}

function removeType(row) {
    ElMessageBox.confirm("确认删除字典“" + (row.dictName || row.dictCode) + "”吗？", "提示", { type: "warning" })
        .then(() => deleteDictTypeFun(row.id))
        .then((res) => {
            if (res.code === 200) {
                ElMessage.success("删除成功");
                if (selectedDict.value?.id === row.id) {
                    selectedDict.value = null;
                }
                loadTypes();
            }
        })
        .catch(() => {});
}

function loadItems() {
    if (!selectedDict.value) {
        return;
    }
    itemLoading.value = true;
    getDictItemPageFun({ ...itemSearch, dictCode: selectedDict.value.dictCode, current: itemPage.current, size: itemPage.size })
        .then((res) => {
            dictItems.value = res.data?.records || [];
            itemPage.total = res.data?.total || 0;
        })
        .finally(() => {
            itemLoading.value = false;
        });
}

function searchItems() {
    itemPage.current = 1;
    loadItems();
}

function resetItemSearch(reload = true) {
    itemSearch.itemCode = "";
    itemSearch.itemName = "";
    itemSearch.status = "";
    itemPage.current = 1;
    if (reload) {
        loadItems();
    }
}

function handleItemSizeChange() {
    itemPage.current = 1;
    loadItems();
}

function openItemDialog(row) {
    itemDialog.form = row ? { ...row } : emptyItemForm();
    itemDialog.visible = true;
}

function saveItem() {
    if (!selectedDict.value) {
        ElMessage.warning("请先选择字典类型");
        return;
    }
    if (!itemDialog.form.itemCode || !itemDialog.form.itemName) {
        ElMessage.warning("请填写字典项编码和名称");
        return;
    }
    saving.value = true;
    saveDictItemFun({ ...itemDialog.form, dictCode: selectedDict.value.dictCode })
        .then((res) => {
            if (res.code === 200) {
                ElMessage.success("保存成功");
                itemDialog.visible = false;
                loadItems();
            }
        })
        .finally(() => {
            saving.value = false;
        });
}

function toggleItemStatus(row) {
    const status = row.status === 1 ? 0 : 1;
    updateDictItemStatusFun(row.id, status).then((res) => {
        if (res.code === 200) {
            ElMessage.success(status === 1 ? "已启用" : "已停用");
            loadItems();
        }
    });
}

function removeItem(row) {
    ElMessageBox.confirm("确认删除字典项“" + (row.itemName || row.itemCode) + "”吗？", "提示", { type: "warning" })
        .then(() => deleteDictItemFun(row.id))
        .then((res) => {
            if (res.code === 200) {
                ElMessage.success("删除成功");
                loadItems();
            }
        })
        .catch(() => {});
}

onMounted(loadTypes);
</script>

<style scoped lang="scss">
.dict-page { padding: 16px; }
.page-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.page-title { font-size: 18px; font-weight: 600; color: #1f2937; }
.page-subtitle { margin-top: 4px; font-size: 12px; color: #8a94a6; }
.dict-layout { display: flex; gap: 12px; align-items: stretch; }
.dict-type-card { width: 46%; min-width: 520px; }
.dict-item-card { flex: 1; min-width: 0; }
.card-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; font-size: 15px; font-weight: 600; }
.selected-dict { margin-left: 10px; font-size: 12px; font-weight: 400; color: #8a94a6; }
.compact-form { margin-bottom: 12px; }
.compact-form :deep(.el-form-item) { margin-bottom: 10px; }
.item-search-form { margin-bottom: 12px; }
.inline-actions { display: flex; justify-content: flex-end; gap: 8px; }
.search-actions { display: flex; justify-content: flex-end; gap: 8px; }
.pagination-box { display: flex; justify-content: flex-end; padding-top: 12px; }
</style>
